module.exports = __webpack_public_path__ + "static/img/culture.70231e56.png";